import { RestService } from '../restService';
import { Method } from '../../models';

export class MethodService extends RestService<Method> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }

    // Backend route: GET /method/methodId/:id
    public async get(id: string): Promise<Method> {
        const client = await this.axiosFactory();
        const response = await client.request<Method>({
            method: 'GET',
            url: `/methodId/${id}`,
        });
        return response?.data as Method;
    }

    // Backend route: GET /method/all/:creator
    public async getByCreator(creatorEmail: string): Promise<Method[]> {
        if (!creatorEmail) return [];
        const client = await this.axiosFactory();
        const response = await client.request<Method[]>({
            method: 'GET',
            url: `/all/${creatorEmail}`,
        });
        return response?.data || [];
    }
}
